import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Box,
  Typography,
  Grid,
  Paper,
  TextField,
  Drawer,
  IconButton,
  Divider,
  Card,
  Chip,
  useTheme,
} from "@material-ui/core";

import ProfileUpdateInfo from "../../components/ProfileUpdateInfo/ProfileUpdateInfo";
import "./compliance.scss";
import ApiConfig from "../../../src/config/ApiConfig";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { documentDetails, deleteDocument } from "../../store/action";
import Notify from "../../components/Notify/Notify";
import PublishIcon from "@material-ui/icons/Publish";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import InsertPhotoOutlinedIcon from "@material-ui/icons/InsertPhotoOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import CreateDatePickerEvent from "./CreateDatePickerEvent";
import AlertDialog from "../../components/Alert/AlertDialog";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CancelIcon from '@material-ui/icons/Cancel';
import Loading from "../../components/Loading";

const useStyles = makeStyles((theme) => ({
  complianceCard: {
    position: "relative",
    borderRadius: "16px",
    padding: "24px 16px",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "170px",
    overflow: "hidden",
    background: (props) => props.background,
    border: (props) => props.border,
    boxShadow: (props) => props.boxShadow,
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: (props) => props.hoverShadow,
    },
  },
  uploadButton: {
    width: "100%",
    height: "48px",
    fontSize: "15px",
    fontWeight: 600,
    background: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    cursor: "pointer",
    borderRadius: "8px",
    border: `2px dashed ${theme.palette.mode === 'dark' ? theme.palette.grey[600] : '#9e9e9e'}`,
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: theme.palette.mode === 'dark' 
        ? "0 4px 16px rgba(33,213,172,0.2)"
        : "0 4px 16px rgba(33,213,172,0.13)",
      borderColor: "#21d5ac",
      color: "#21d5ac",
    },
  },
  documentItem: {
    padding: "12px 16px",
    marginBottom: "12px",
    borderRadius: "8px",
    backgroundColor: theme.palette.mode === 'dark' 
      ? theme.palette.grey[800] 
      : theme.palette.grey[50],
    border: `1px solid ${theme.palette.divider}`,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.mode === 'dark' 
        ? theme.palette.grey[700] 
        : theme.palette.grey[100],
      transform: "translateX(4px)",
    },
  },
  statusIndicator: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    marginRight: "12px",
    flexShrink: 0,
  },
  drawerPaper: {
    width: "700px",
    borderRadius: "0px",
    padding: "24px",
    backgroundColor: theme.palette.background.default,
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "1.1rem",
    color: theme.palette.text.primary,
    marginBottom: "16px",
    paddingBottom: "8px",
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  actionButton: {
    borderRadius: "8px",
    padding: "8px 16px",
    fontWeight: 500,
    textTransform: "none",
  },
  progressBar: {
    height: "6px",
    borderRadius: "3px",
    backgroundColor: theme.palette.mode === 'dark' 
      ? theme.palette.grey[700] 
      : theme.palette.grey[200],
    overflow: "hidden",
    marginTop: "8px",
  },
  progressFill: {
    height: "100%",
    borderRadius: "3px",
    backgroundColor: "#21d5ac",
    transition: "width 0.3s ease",
  },
  pageTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  clickHint: {
    color: theme.palette.grey[700],
  },
  emptyState: {
    color: theme.palette.text.secondary,
    textAlign: "center",
    padding: "16px",
  },
}));

const ComplianceList = () => {
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const getToken = localStorage.getItem("token")
    ? localStorage.getItem("token").replace(/['"]+/g, "")
    : "";
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const [expanded, setExpanded] = useState(false);
  const [key2, setKey] = useState("");
  const { documentDetail, documentDetailError, loading } = useSelector(
    (state) => state.addCompliance
  );

  const [key1, aetKey1] = useState("");
  const [addDocMsg, setAddDocMsg] = useState("");
  const [fileSizeMsg, setFileSize] = useState("");
  const [notifyMsg, setNotifyMsg] = useState(false);
  const [loader, setLoader] = useState(false);
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  var signeeInfo = JSON.parse(window.localStorage.getItem("signeeInfo"));
  const user_id = signeeInfo.id;
  const baseUrl = ApiConfig.API_URL + "uploads/signee_docs/";
  const [expireDate, setExpireDate] = useState(null);
  const [openRemarkDocument, setOpenRemarkDocument] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [deleteDocOpen, setDeleteDocOpen] = useState(false);
  const [docId, setDocsId] = useState(false);
  const [complainceStatus, setComplainceStatus] = useState({
    signee_id: user_id,
    organization_id: "",
    key: "",
    document_status: "",
  });
  const [remarksDocument, setRemarksDocument] = useState({
    document_subkey: "",
    document_id: "",
    remark: "",
  });

  const [exDateDocument, setDatePicker] = useState({
    document_subkey: "",
    document_id: "",
    expire_date: "",
  });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [progress, setProgress] = useState({});

  const getCardStyles = (status) => {
    const isDark = theme.palette.mode === 'dark';
    
    const baseStyles = {
      green: {
        background: isDark 
          ? "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)" 
          : "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
        border: isDark ? "1px solid #2e7d32" : "1px solid rgba(255, 255, 255, 0.5)",
        boxShadow: isDark 
          ? "0 4px 20px rgba(0, 0, 0, 0.3)" 
          : "0 4px 20px rgba(0, 0, 0, 0.08)",
        hoverShadow: isDark 
          ? "0 12px 28px rgba(0, 0, 0, 0.4)" 
          : "0 12px 28px rgba(0, 0, 0, 0.15)",
      },
      yellow: {
        background: isDark 
          ? "linear-gradient(135deg, #f57f17 0%, #f9a825 100%)" 
          : "linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%)",
        border: isDark ? "1px solid #f9a825" : "1px solid rgba(255, 255, 255, 0.5)",
        boxShadow: isDark 
          ? "0 4px 20px rgba(0, 0, 0, 0.3)" 
          : "0 4px 20px rgba(0, 0, 0, 0.08)",
        hoverShadow: isDark 
          ? "0 12px 28px rgba(0, 0, 0, 0.4)" 
          : "0 12px 28px rgba(0, 0, 0, 0.15)",
      },
      red: {
        background: isDark 
          ? "linear-gradient(135deg, #c62828 0%, #d32f2f 100%)" 
          : "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
        border: isDark ? "1px solid #d32f2f" : "1px solid rgba(255, 255, 255, 0.5)",
        boxShadow: isDark 
          ? "0 4px 20px rgba(0, 0, 0, 0.3)" 
          : "0 4px 20px rgba(0, 0, 0, 0.08)",
        hoverShadow: isDark 
          ? "0 12px 28px rgba(0, 0, 0, 0.4)" 
          : "0 12px 28px rgba(0, 0, 0, 0.15)",
      },
      default: {
        background: isDark 
          ? "linear-gradient(135deg, #1e2a3a 0%, #2d3748 100%)" 
          : "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
        border: isDark ? "1px solid #334155" : "1px solid rgba(255, 255, 255, 0.5)",
        boxShadow: isDark 
          ? "0 4px 20px rgba(0, 0, 0, 0.3)" 
          : "0 4px 20px rgba(0, 0, 0, 0.08)",
        hoverShadow: isDark 
          ? "0 12px 28px rgba(0, 0, 0, 0.4)" 
          : "0 12px 28px rgba(0, 0, 0, 0.15)",
      }
    };

    return baseStyles[status] || baseStyles.default;
  };

  const handleClick = (e, keyData) => {
    setKey(keyData);
    setSelectedFile(e.target.files);
    setFileSize("");
    setOpenDrawer(false);
    dispatch(documentDetails("", user_id));
  };

  const handleCloseDatePicker = () => {
    setOpenDatePicker(false);
  };

  useEffect(() => {
    if (selectedFile && selectedFile.length > 0) {
      let totalLength = 0;
      if (selectedFile && selectedFile.length <= 5) {
        for (const key of Object.keys(selectedFile)) {
          const fsize = selectedFile.item(key).size;
          const file2 = Math.round(fsize / 1024);
          totalLength += file2;
        }
        if (totalLength <= 20480) {
          onSubmit();
        } else {
          setFileSize("File size should be less than 20MB");
        }
      } else {
        setFileSize("Maximum 5 documents allowed");
      }
    }
  }, [selectedFile]);

  const handleComplianceStatus = (event, org_id) => {
    setComplainceStatus({
      ...complainceStatus,
      key: event.target.name,
      document_status: event.target.value,
      organization_id: org_id,
    });
  };

  const handleClickOpenDatePicker = (
    document_subkey,
    document_id,
    expire_date
  ) => {
    setDatePicker({
      document_subkey: document_subkey,
      document_id: document_id,
      expire_date,
    });
    setOpenDatePicker(true);
    dispatch(documentDetails("", user_id));
  };

  const deleteDocClose = () => {
    setDeleteDocOpen(false);
  };

  const deleteDocResponse = (id) => {
    dispatch(deleteDocument(id));
    dispatch(documentDetails("", user_id));
    setOpenDrawer(false);
  };

  const deleteDocumentData = (id) => {
    setDeleteDocOpen(true);
    setDocsId(id);
    setOpenDrawer(false);
  };

  const handleClickOpenRemarkDocument = (
    document_subkey,
    document_id,
    remark
  ) => {
    setRemarksDocument({
      document_subkey: document_subkey,
      document_id: document_id,
      remark,
    });
    setOpenDrawer(false);
    setOpenRemarkDocument(true);
  };

  const onSubmit = (e) => {
    let formData = new FormData();

    for (const key of Object.keys(selectedFile)) {
      formData.append("files[]", selectedFile[key]);
      formData.append("key", key2);
      formData.append("user_id", user_id);
    }
    setAddDocMsg("");

    axios
      .post(ApiConfig.API_URL + "api/signee/upload-document", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: getToken ? `Bearer ${getToken}` : "",
        },
        onUploadProgress: (progressEvent) => {
          setLoader(true);
          const percentage = parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
          setUploadPercentage(percentage);
          setProgress(prev => ({...prev, [key2]: percentage}));
        },
      })
      .then(function (response) {
        const dataItem = response.data;
        if (dataItem && dataItem.status === true) {
          dispatch(documentDetails("", user_id));
          setLoader(false);
          setNotifyMsg(true);
          setAddDocMsg("Document Uploaded Successfully");
          setProgress(prev => ({...prev, [key2]: 0}));
        }
      })
      .catch(function (error) {
        setLoader(false);
        setAddDocMsg(error.message);
        setProgress(prev => ({...prev, [key2]: 0}));
      });
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleOpenDrawer = (doc) => {
    setSelectedDoc(doc);
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setSelectedDoc(null);
    setOpenDrawer(false);
  };

  const getDocUploadedStatus = (docs) => {
    const tempDocs = Object.entries(docs);
    if (
      !tempDocs?.find(
        (obj) => obj?.[1]?.docs?.filter((d) => d.file_name)?.length > 0
      )
    ) {
      return "red";
    } else {
      for (const [, sectionData] of tempDocs) {
        if (!sectionData.docs.length) {
          return "yellow";
        }
        for (const doc of sectionData.docs) {
          if (
            doc.document_status !== "SUCCESS" &&
            doc.document_status !== "REJECTED" &&
            doc.is_checked !== 0
          ) {
            return "yellow";
          }
        }
      }
      return "green";
    }
  };

  const getDocStatusColor = (docs) => {
    const status = getDocUploadedStatus(docs);
    
    switch(status) {
      case "green": 
        return {
          icon: <CheckCircleIcon style={{ color: theme.palette.mode === 'dark' ? "#81c784" : "#4caf50", fontSize: 48 }} />
        };
      case "yellow":
        return {
          icon: <WarningIcon style={{ color: theme.palette.mode === 'dark' ? "#ffd54f" : "#ffc107", fontSize: 48 }} />
        };
      case "red":
        return {
          icon: <CancelIcon style={{ color: theme.palette.mode === 'dark' ? "#ef5350" : "#f44336", fontSize: 48 }} />
        };
      default:
        return {
          icon: <HelpOutlineIcon style={{ color: theme.palette.text.secondary, fontSize: 48 }} />
        };
    }
  };

  const getStatusText = (status) => {
    switch(status) {
      case "green": return "Complete";
      case "yellow": return "In Progress";
      case "red": return "Action Needed";
      default: return "Not Started";
    }
  };

  useEffect(() => {
    dispatch(documentDetails("", user_id));
  }, [dispatch, user_id]);

  return (
    <>
      {loading || loader && <Loading open={loading || loader} />}
     
      {notifyMsg && addDocMsg && <Notify data={addDocMsg} status="success" />}

      {fileSizeMsg && <Notify data={fileSizeMsg} status="error" />}
      <ProfileUpdateInfo />

      <section className="pt-16 pb-32">
        <div className="mb-8">
          <h1 className={classes.pageTitle}>Compliance Documents</h1>
        </div>
        
        <Box component="form" onSubmit={(e) => {e.preventDefault(); onSubmit(e);}} mt={3}>
          <Grid container spacing={3}>
            {documentDetail?.data &&
              Object.entries(documentDetail?.data || {}).map((list, index) => {
                const allItemsHidden = list[1].data && Object.values(list[1].data || {}).every((item) => item.is_hide);

                if (!allItemsHidden) {
                  const statusInfo = getDocStatusColor(list[1]?.data || {});
                  const status = getDocUploadedStatus(list[1]?.data || {});
                  const cardStyles = getCardStyles(status);
                  
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Card
                        className={classes.complianceCard}
                        style={cardStyles}
                        onClick={() => handleOpenDrawer(list[1])}
                      >
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                          <Box>
                            <Typography 
                              variant="subtitle1" 
                              style={{
                                fontWeight: 600,
                                color: theme.palette.grey[700],
                                marginBottom: "8px"
                              }}
                            >
                              {list[1].title}
                            </Typography>
                            <Chip 
                              label={getStatusText(status)} 
                              size="small"
                              style={{
                                backgroundColor: status === "green" ? "#4caf50" : 
                                                status === "yellow" ? "#ffc107" : "#f44336",
                                color: "white",
                                fontWeight: 500
                              }}
                            />
                          </Box>
                          {statusInfo.icon}
                        </Box>
                        
                        {progress[list[1].key] > 0 && (
                          <Box className={classes.progressBar}>
                            <Box 
                              className={classes.progressFill} 
                              style={{ width: `${progress[list[1].key]}%` }}
                            />
                          </Box>
                        )}
                        
                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                          <Typography variant="caption" className={classes.clickHint}>
                            Click to view details
                          </Typography>
                          <ArrowForwardIosIcon fontSize="small" className={classes.clickHint} />
                        </Box>
                      </Card>
                    </Grid>
                  );
                }
                return null;
              })}
          </Grid>
        </Box>

        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={handleCloseDrawer}
          PaperProps={{ className: classes.drawerPaper }}
        >
          {selectedDoc ? (
            <>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h5" style={{ fontWeight: 600, color: theme.palette.text.primary }}>
                  {selectedDoc.title}
                </Typography>
                <IconButton onClick={handleCloseDrawer}>
                  <CancelIcon />
                </IconButton>
              </Box>
              
              <Divider style={{ marginBottom: "24px" }} />

              <Grid container spacing={3}>
                {Object.entries(selectedDoc?.data || {}).map(([childKey, child], idx) => {
                  if (child?.is_hide) return null;
                  return (
                    <Grid item xs={12} key={childKey || idx}>
                      <Paper 
                        elevation={0} 
                        style={{ 
                          padding: "20px", 
                          borderRadius: "12px",
                          backgroundColor: theme.palette.background.paper,
                          border: `1px solid ${theme.palette.divider}`
                        }}
                      >
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                          <Typography variant="subtitle1" style={{ fontWeight: 600, color: theme.palette.text.primary }}>
                            {child?.subTitle}
                          </Typography>
                          <Chip 
                            label={child?.docs[0]?.document_status || complainceStatus?.document_status || "PENDING"} 
                            size="small"
                            style={{
                              backgroundColor: 
                                (child?.docs[0]?.document_status === "SUCCESS") ? "#4caf50" :
                                (child?.docs[0]?.document_status === "REJECTED") ? "#f44336" : "#ffc107",
                              color: "white"
                            }}
                          />
                        </Box>
                        
                        {/* Upload Button */}
                        <button
                          type="button"
                          className={classes.uploadButton}
                        >
                          <PublishIcon style={{ color: "#21d5ac", fontSize: 22, marginRight: "8px" }} />
                          <input
                            accept="image/*,.pdf"
                            type="file"
                            multiple
                            name="files"
                            onChange={(e) => handleClick(e, child?.subKey)}
                            className={classes.uploadFile}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              opacity: 0,
                              cursor: "pointer",
                            }}
                          />
                          <span style={{ fontWeight: 600, letterSpacing: 1 }}>Upload Documents</span>
                        </button>

                        {progress[child?.subKey] > 0 && (
                          <Box className={classes.progressBar}>
                            <Box 
                              className={classes.progressFill} 
                              style={{ width: `${progress[child?.subKey]}%` }}
                            />
                          </Box>
                        )}
                        
                        {/* Documents List */}
                        {Array.isArray(child?.docs) && child.docs.length > 0 ? (
                          <Box mt={2}>
                            <Typography variant="caption" display="block" gutterBottom style={{ color: theme.palette.text.secondary }}>
                              Uploaded documents:
                            </Typography>
                            {child.docs.map((docItem, i) => (
                              <Paper
                                key={docItem?.id ?? i}
                                className={classes.documentItem}
                              >
                                <Grid container alignItems="center" spacing={2}>
                                  <Grid item xs={7}>
                                    <Box display="flex" alignItems="center">
                                      {docItem.file_name?.endsWith('.pdf') ? (
                                        <PictureAsPdfIcon style={{ color: "#e53e3e", marginRight: "8px" }} />
                                      ) : (
                                        <InsertPhotoOutlinedIcon style={{ color: "#4299e1", marginRight: "8px" }} />
                                      )}
                                      <a
                                        href={`${baseUrl}${docItem.file_name}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: theme.palette.mode === 'dark' ? '#90cdf4' : '#2b6cb0',
                                          textDecoration: "none",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          display: "block",
                                        }}
                                      >
                                        {docItem.file_name}
                                      </a>
                                    </Box>
                                  </Grid>

                                  <Grid item xs={5}>
                                    <Box display="flex" alignItems="center" justifyContent="flex-end">
                                      <TextField
                                        value={
                                          docItem?.expire_date
                                            ? moment(docItem.expire_date).format("DD/MM/YYYY")
                                            : ""
                                        }
                                        readOnly
                                        size="small"
                                        variant="outlined"
                                        onClick={() =>
                                          handleClickOpenDatePicker(
                                            child?.subKey,
                                            child.docs[i],
                                            docItem?.expire_date
                                              ? moment(docItem.expire_date).format("YYYY-MM-DD")
                                              : ""
                                          )
                                        }
                                        style={{ marginRight: "8px", width: "120px" }}
                                      />

                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteDocumentData(docItem?.id);
                                        }}
                                        aria-label="delete document"
                                        style={{ color: "#e53e3e" }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Paper>
                            ))}
                          </Box>
                        ) : (
                          <Typography variant="body2" className={classes.emptyState}>
                            No documents uploaded yet
                          </Typography>
                        )}
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            </>
          ) : (
            <Typography variant="body1">Select a document to view details</Typography>
          )}
        </Drawer>

        <CreateDatePickerEvent
          open={openDatePicker}
          close={setOpenDatePicker}
          closeSidebar={setOpenDrawer}
          handleClose={handleCloseDatePicker}
          signee_id={user_id}
          expire_date={exDateDocument}
          setExpireDate={expireDate}
        />
        <AlertDialog
          id={docId}
          open={deleteDocOpen}
          close={deleteDocClose}
          response={deleteDocResponse}
          title="Delete Candidate Document"
          description="Are you sure you want to delete?"
          buttonName="Delete"
        />
      </section>
    </>
  );
};

export default ComplianceList;